<template>
  <div class="userInfoWrapper">
    <b-dropdown
      v-b-tooltip.hover
      :title="'Update chart data'"
      id="dropdown-1"
      text="Dropdown Button"
      class="exportDropDown text-dark"
      offset="-50"
      no-caret
      variant="link"
    >
      <template v-slot:button-content>
        <!-- <i class="fas fa-download"></i> -->
        <img :src="upload_download_src" class="upload_download" alt="">
      </template>
      <b-dropdown-item type="button">
        <download-excel
          class="text-nowrap"
          :fetch="downloadExcel"
          worksheet="Data"
          type="csv"
          :name="chartName + '.csv'"
        >
          Download Chart Template
        </download-excel>
      </b-dropdown-item>
      <b-dropdown-item
        type="button"
        @click="chartUpdate"
        data-toggle="modal"
        data-target="#exampleModal"
      >
        Chart Data Update
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import upload_download from "@/assets/upload-download_file.svg"
import JsonExcel from "vue-json-excel";

export default {
  components: {
    "download-excel": JsonExcel,
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo",
      historyCalDropDown: "historyCalDropDown",
    }),
  },
  data() {
    return {
      upload_download_src: upload_download,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      chartName:"ER-Dashboard"
    };
  },
  mounted() {
    this.updateDownloadHandler(false);
  },
  methods: {
    ...mapActions(["updateDownloadHandler", "chartDownloadHandler"]),
    async downloadExcel() {
      let chart_id = this.historyCalDropDown.current_version.chart_id;
      let downloadData = await this.chartDownloadHandler(chart_id);
      let data = downloadData.data;
      this.chartName = downloadData.chart_name.name;
      if (data.length) {
        // console.log("data++", data);
        return data;
      }
      return [];
    },
    chartUpdate() {
      this.updateDownloadHandler(true);
      // console.log("ccccccccccccccc");
    },
  },
};
</script>
<style scoped>
/*--------Source Tab-------------*/
.userInfoWrapper {
  background-color: #fff;
}
.iframe-userinfo .userInfoWrapper {
  bottom: 1px;
}
.userInfoWrapper {
  display: inline-block;
  right: 10px;
  bottom: 10px;
  z-index: 50;
}
.userInfoWrapper .info-card-container {
  display: none;
  position: absolute;
  right: 0.5rem;
  top: 100%;
  z-index: 50;
  width: max-content;
  border: 1px solid silver;
  background-color: #fff;
  text-align: left;
}
.info-icon:hover .info-card-container {
  display: block !important;
}
.info-icon {
  width: 20px;
  height: 20px;
}
.userInfoTab {
  font-size: 11px;
  /* padding: 0px 5px 0px 5px; */
}
.upload_download {
  height: 20px;
  widows: 20px;
}
</style>
